import { TopMenuButtonProps } from '../TopMenu.types'
import './TopMenuButton.css'

export const TopMenuButton = (props: TopMenuButtonProps) => {

	const getBackgroundColor = () => {
		if (!props.styles?.button?.active?.backgroundColor || !props.styles?.button?.inactive?.backgroundColor) {
			return props.isActive ? "#FD0282" : "#fff"
		}
		return props.isActive ? props.styles?.button?.active?.backgroundColor : props.styles?.button?.inactive?.backgroundColor
	}

	const getColor = () => {
		if (!props.styles?.button?.active?.color || !props.styles?.button?.inactive?.color) {
			return props.isActive ? "#fff" : "#341733"
		}
		return props.isActive ? props.styles?.button?.active?.color : props.styles?.button?.inactive?.color
	}


	return (
		<div
			className={`freeroam-menu-button ${props.isActive ? "active" : null}`}
			onClick={props.onClick}
			style={{ backgroundColor: getBackgroundColor(), color: getColor() }}
		>
			<p className='freeroam-menu-button-text'>{props.text}</p>
		</div>
	)
}